import { render, staticRenderFns } from "./LinkedProfessionals.vue?vue&type=template&id=3bf2a07e"
import script from "./LinkedProfessionals.vue?vue&type=script&lang=js"
export * from "./LinkedProfessionals.vue?vue&type=script&lang=js"
import style0 from "./LinkedProfessionals.vue?vue&type=style&index=0&id=3bf2a07e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports